import { toast } from "sonner";
import baseApi from "store/api/baseApi";

const clientManagementApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    // Get all clients
    getAllClients: builder.query({
      query: () => ({
        url: "qwikITClient/",
        method: "GET",
      }),
      providesTags: ["client"],
      transformResponse: response => response.reverse(),
    }),

    // Get a single client by ID
    getClient: builder.query({
      query: id => ({
        url: `qwikITClient/${id}/`,
        method: "GET",
      }),
      providesTags: ["client"],
      transformResponse: response => response,
    }),

    getClientByUserId: builder.query({
      query: userId => ({
        url: `qwikITClient/?user=${userId}`, // assuming your API supports filtering by user
        method: "GET",
      }),
      providesTags: ["client"],
      transformResponse: response => Array.isArray(response) ? response[0] : response,
    }),

    // Create a new client
    createClient: builder.mutation({
      query: data => ({
        url: "qwikITClient/new/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["client"],
      transformResponse: response => {
        toast.success("Client created successfully");
        return response;
      },
    }),

    // Update client
    updateClient: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `qwikITClient/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["client"],
      transformResponse: response => {
        toast.success("Client updated successfully");
        return response;
      },
    }),

    // Delete client
    deleteClient: builder.mutation({
      query: id => ({
        url: `qwikITClient/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["client"],
      transformResponse: response => {
        toast.success("Client deleted successfully");
        return response;
      },
    }),
  }),
});

const projectManagementApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getAllProjects: builder.query({
      query: () => ({
        url: "qwikITProject/",
        method: "GET",
      }),
      providesTags: ["projects"],
      transformResponse: response => response.reverse(),
    }),

    getProjectById: builder.query({
      query: id => ({
        url: `qwikITProject/${id}/`,
        method: "GET",
      }),
      providesTags: ["projects"],
      transformResponse: response => response,
    }),

    createProject: builder.mutation({
      query: data => ({
        url: "qwikITProject/new/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["projects"],
      transformResponse: response => {
        toast.success("Project created successfully");
        return response;
      },
    }),

    // updateProject: builder.mutation({
    //   query: ({ id, ...data }) => ({
    //     url: `qwikITProject/${id}/`,
    //     method: "PATCH",
    //     body: data,
    //   }),
    //   invalidatesTags: ["projects"],
    //   transformResponse: response => {
    //     toast.success("Project updated successfully");
    //     return response;
    //   },
    // }),

    updateProject: builder.mutation({
      query: ({ id, formData }) => ({
        url: `qwikITProject/${id}/`,
        method: "PATCH",
        body: formData,
        headers: {

        },
      }),
      invalidatesTags: ["projects"],
      transformResponse: response => {
        toast.success("Project updated successfully");
        return response;
      },
    }),



    // Add delete project mutation
    deleteProject: builder.mutation({
      query: id => ({
        url: `qwikITProject/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["projects"],
      transformResponse: response => {
        toast.success("Project deleted successfully");
        return response;
      },
    }),


  }),
});

const workLogApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    // Get all work logs
    getAllWorkLogs: builder.query({
      query: () => ({
        url: "qwikITWorkLog/",
        method: "GET",
      }),
      providesTags: ["worklog"],
      transformResponse: response => response.reverse(),
    }),

    // Get work logs by employer ID
    getWorkLogsByEmployer: builder.query({
      query: employerId => ({
        url: `qwikITWorkLog/?employer_id=${employerId}`,
        method: "GET",
      }),
      providesTags: ["worklog"],
    }),

    // Get work logs by date
    getWorkLogsByDate: builder.query({
      query: date => ({
        url: `qwikITWorkLog/?date=${date}`,
        method: "GET",
      }),
      providesTags: ["worklog"],
    }),

    // Create work log
    createWorkLog: builder.mutation({
      query: data => ({
        url: "qwikITWorkLog/new/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["worklog"],
      transformResponse: response => {
        toast.success("Work log added successfully");
        return response;
      },
    }),

    // Update work log
    updateWorkLog: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `qwikITWorkLog/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["worklog"],
      transformResponse: response => {
        toast.success("Work log updated successfully");
        return response;
      },
    }),

    // Delete work log
    deleteWorkLog: builder.mutation({
      query: id => ({
        url: `qwikITWorkLog/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["worklog"],
      transformResponse: response => {
        toast.success("Work log deleted successfully");
        return response;
      },
    }),
  }),
});

export const {
  useGetAllWorkLogsQuery,
  useGetWorkLogsByEmployerQuery,
  useGetWorkLogsByDateQuery,
  useCreateWorkLogMutation,
  useUpdateWorkLogMutation,
  useDeleteWorkLogMutation,
} = workLogApi;

export const {
  useGetAllClientsQuery,
  useGetClientQuery,
  useGetClientByUserIdQuery,
  useCreateClientMutation,
  useUpdateClientMutation,
  useDeleteClientMutation,
} = clientManagementApi;

export const {
  useGetAllProjectsQuery,
  useGetProjectByIdQuery,
  useCreateProjectMutation,
  useUpdateProjectMutation,
  useDeleteProjectMutation
} = projectManagementApi;


// import { toast } from "sonner"
// import baseApi from "store/api/baseApi"

// const clientManagementApi = baseApi.injectEndpoints({
//   endpoints: builder => ({
//     // Get a single client by ID
//     getClient: builder.query({
//       query: id => ({
//         url: `qwikITClient/${id}/`,
//         method: "GET",
//       }),
//       providesTags: ["client"],
//     }),

//     // Get all clients
//     getAllClients: builder.query({
//       query: () => ({
//         url: "qwikITClient/",
//         method: "GET",
//       }),
//       providesTags: ["client"],
//     }),

//     // Create a new client
//     createClient: builder.mutation({
//       query: data => ({
//         url: "qwikITClient/new/",
//         method: "POST",
//         body: data,
//       }),
//       invalidatesTags: ["client"],
//       transformResponse: response => {
//         // toast.success("Client created successfully")
//         return response
//       },
//     }),

//     // Update client
//     updateClient: builder.mutation({
//       query: ({ id, ...data }) => ({
//         url: `qwikITClient/${id}/`,
//         method: "PUT",
//         body: data,
//       }),
//       invalidatesTags: ["client"],
//       transformResponse: response => {
//         toast.success("Client updated successfully")
//         return response
//       },
//     }),

//     // Delete client
//     deleteClient: builder.mutation({
//       query: id => ({
//         url: `qwikITClient/${id}/`,
//         method: "DELETE",
//       }),
//       invalidatesTags: ["client"],
//       transformResponse: response => {
//         toast.success("Client deleted successfully")
//         return response
//       },
//     }),
//   }),
// })

// export const {
//   useGetClientQuery,
//   useGetAllClientsQuery,
//   useCreateClientMutation,
//   useUpdateClientMutation,
//   useDeleteClientMutation,
// } = clientManagementApi

// export default clientManagementApi
